import * as React from 'react'
import { cn } from 'utils/classNames'
import { Slot } from '@radix-ui/react-slot'
import { cva, VariantProps } from 'class-variance-authority'

const buttonVariants = cva(
  'text-md inline-flex items-center justify-center rounded-sm border border-transparent bg-brandGrayLight-200 px-4 py-2 text-black shadow-sm transition-all' +
    'hover:bg-brandGrayLight-500 dark:bg-brandGrayDark-600 dark:text-white dark:hover:bg-brandGrayDark-500',
  {
    variants: {
      variant: {
        default: '',
        disabled:
          'cursor-not-allowed bg-brandGrayLight-400 text-brandGrayLight-650 hover:bg-brandGrayLight-100 dark:bg-brandGrayDark-700 dark:text-brandGrayDark-100 dark:hover:bg-brandGrayDark-700',
        primary:
          'bg-brand-300 text-white hover:bg-brand-400 dark:bg-brand-300 dark:hover:bg-brand-400',
        ghost: 'bg-transparent hover:bg-accent hover:text-accent-foreground',
        link: 'text-primary underline-offset-4 hover:underline',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface ButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
  primary?: boolean
}

// eslint-disable-next-line react/display-name
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, asChild = false, primary, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    const { disabled } = props
    if (primary) variant = 'primary'
    if (disabled) variant = 'disabled'

    return (
      <Comp
        className={cn(buttonVariants({ variant, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
